import script from "./PreviewPicture.vue?vue&type=script&lang=ts&setup=true"
export * from "./PreviewPicture.vue?vue&type=script&lang=ts&setup=true"

import "./PreviewPicture.vue?vue&type=style&index=0&id=ce419a72&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce419a72"]])

export default __exports__